<template>
  <div>
    <v-data-table
      class="data-table-interest elevation-0 border-2"
      :loading="loading"
      :items="areaInterests"
      :headers="headers"
      :items-per-page="50"
      :footer-props="{ itemsPerPageOptions: [50, 100, 200] }"
      :search="search"
      :no-data-text="$t('noinfo')"
      :no-results-text="$t('no_matching_records_found')">
     
      <template v-slot:header.getCustomerName="{header}">
        <div class="text-nowrap-table text-center" style="min-width: 150px;">{{header.text}}</div>
      </template>
      <template v-slot:header.marketName="{header}"> 
        <div class="text-nowrap-table text-center" style="min-width: 100px;">{{header.text}}</div>
      </template>
      <template v-slot:header.productNames="{header}">
        <div class="text-nowrap-table text-center" style="min-width: 200px;">{{header.text}}</div>
      </template>
      <template v-slot:header.areasString="{header}">
        <span>
        <div class="text-nowrap-table text-center" style="min-width: 100px;">{{header.text}}</div>
        </span>
      </template>

      <template v-slot:item.getCustomerName="{ item }">
        <div class="text-truncate">
          <div class="d-flex align-center text-truncate">
            <v-tooltip top color="success" v-if="item.isFromURL">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" >
                  <v-btn
                    color="primary"
                    text
                    fab
                    x-small
                    dark
                    elevation="0"
                    style="pointer-events: none; width: 17px; height: 17px; padding: 10px;"
                    class="me-1 bg-green-100"
                  >
                    <v-icon style="font-size: 14px;">mdi-link</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>{{ $t('customer.input_data_from_url') }}</span>
            </v-tooltip>
            <div class=" text-truncate">
              {{ item.getCustomerName }}
            </div>
          </div>
        </div>
      </template>
      <!-- <template v-slot:item.marketName="{ item }">
        <td class="hd-resize market-name text-truncate">
          {{ item.marketName }} 
        </td>
      </template> -->
      <template v-slot:item.productNames="{ item }">
        <div class=" product-name text-truncate">
          {{ item.productNames && item.productNames.length ? item.productNames.join(',') : '' }}
        </div>
      </template>
      <template v-slot:item.areasQty="{ item }">
        <div class=" product-name text-center">
          {{ item.areasQty}}
        </div>
      </template>
      <template v-slot:item.areasString="{ item }">
        <div class="text-truncate area-name text-center">
          {{ item.areasString }}
        </div>
      </template>
      <template v-slot:item.getStatusString="{ item }">
        <div class="text-start">
          <div class="max-w-sm">
            <v-chip class="chip-status" :class="item.statusColor">
              <v-icon left x-small> mdi-circle </v-icon>
              {{ item.getStatusString }}
            </v-chip>
          </div>
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="flex justify-center">
          <v-btn color="grey lighten-4 d-block" elevation="0" rounded small @click="onClickEdit(item)">
            {{ $t('detail') }}</v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      isLoading: false,
      headers: [],
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    search: String
  },
  created() {
    this.headers = [
        {
          text: this.$t('date'),
          align: "center",
          // sortable: false,
          value: "createdAtString",
        },
        {
          text: this.$t('market.customer_name_and_company'),
          align: "center hd-resize",
          sortable: false,
          value: "getCustomerName",
          width: "100px"
        },
        // {
        //   text: "รายละเอียดตลาด",
        //   align: "center",
        //   sortable: false,
        //   value: "marketName",
        //   width: "100px",
        // },
        {
          // ประเภทผู้ค้า
          text: this.$t('customer.customer_type'),
          align: "center",
          value: "customerTypeString",
          class: 'whitespace-nowrap',
          width: "100px",
        },
        {
          text: this.$t('contract.start_date'),
          align: "center",
          // sortable: false,
          value: "contractStartDateString",
          class: 'whitespace-nowrap'
        },
        {
          text: this.$t('contract.end_date'),
          align: "center",
          // sortable: false,
          value: "contractEndDateString",
          class: 'whitespace-nowrap'
        },
        {
          text: this.$t('area.interested_stall'),
          align: "center",
          // sortable: false,
          value: "areasQty",
          class: 'whitespace-nowrap'
        },
        {
          text: this.$t('product.product_in_sell'),
          align: "center  hd-resize",
          sortable: false,
          value: "productNames",
          class: 'whitespace-nowrap'
        },
        {
          text: this.$t('area.stall_number'),
          align: "center  hd-resize",
          // sortable: false,
          value: "areasString",
          class: 'whitespace-nowrap custom-sort'
        },
        {
          width: "165px",
          text: this.$t('status'),
          value: "getStatusString",
          align: "center",
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "action",
        },
    ];
  },
  computed: {
    ...mapGetters({
      areaInterests: "areaInterest/areaInterests",
    }),
  },
  methods: {
    onClickEdit(item) {
      this.$emit("onClickEdit", item);
    },
  },
};
</script>

<style scoped lang="scss">

.data-table-interest::v-deep th {
  padding: 0 8px !important;
}
.data-table-interest::v-deep td {
  max-width: 100px;
  padding: 0 8px !important;
}

.data-table-interest::v-deep td.hd-resize {
  max-width: 100px;
}
.data-table-interest::v-deep td.hd-resize.area-name {
  max-width: 100px;
}

.data-table-interest::v-deep th.custom-sort {
  position: relative;
  .v-icon{
    position: absolute;
    right: 24px;
    top: 18px;
  }
}
</style>